<template>
    <div>
        <div
            v-if="users.length > 1"
            class="px-4 sm:px-6 lg:px-8 py-0 pt-6 w-full max-w-9xl mx-auto"
        >
            <div class="flex justify-between items-center">
                <ul class="pill-list mb-3">
                    <li v-for="(user, uIndex) in users" :key="'ukey-' + uIndex">
                        <a
                            class="pill"
                            href="#"
                            role="button"
                            :class="{ dark: user.active }"
                            @click.prevent="toggleUserShown(user)"
                        >
                            {{ user.name }}
                        </a>
                    </li>
                </ul>
                <a
                    href="#"
                    @click.prevent="setShowAffiliateModal(true)"
                    class="text-orange text-xs hover:text-orange-400 self-center whitespace-nowrap"
                >
                    Affiliate Disclosure
                </a>
            </div>
        </div>
        <div class="px-4 sm:px-6 lg:px-8 py-0 w-full max-w-9xl mx-auto">
            <StartGuide />
        </div>

        <div class="px-4 sm:px-6 lg:px-8 py-0 w-full max-w-9xl mx-auto">
            <div
                class="flex px-6 pt-5 pb-6 gap-6 self-stretch rounded-md bg-white shadow-lg mt-6 z-0"
            >
                <dl
                    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full"
                >
                    <div class="md:border-r-2 border-gray-100">
                        <NumberOfCards />
                    </div>
                    <div class="lg:border-r-2 border-gray-100">
                        <NumberOfPoints />
                    </div>
                    <div class="md:border-r-2 border-gray-100">
                        <AnnualFees />
                    </div>
                    <div class="md:border-gray-100 md:border-0">
                        <FiveTwentyFour />
                    </div>
                </dl>
            </div>
        </div>
        <div class="px-4 sm:px-6 lg:px-8 py-6 w-full max-w-9xl mx-auto">
            <TopCard />
        </div>

        <div class="px-4 sm:px-6 lg:px-8 py-6 w-full max-w-9xl mx-auto">
            <div class="grid grid-cols-12 gap-4">
                <CreditScore :onDashboard="true" />
                <TxCourses v-if="courseProgress === 0" />
                <CourseProgress v-else />
            </div>
        </div>
    </div>
    <div class="px-4 sm:px-6 lg:px-8 w-full max-w-9xl mx-auto">
        <div class="grid grid-cols-2 gap-4">
            <SwCompanionPass v-if="passEnabled" />
            <CompanionPassSection v-else />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'pinia';
import { useDashboardStore } from '@/store/dashboard';
import { useCreditScoreStore } from '@/store/creditscore';
import { useCompanionPassStore } from '@/store/companionpass';
import { useAppStore } from '@/store/app';
import { useCoursesStore } from '@/store/courses';
import FiveTwentyFour from '@/components/dashboard/cards/five-twenty-four.vue';
import NumberOfCards from '@/components/dashboard/cards/number-of-cards.vue';
import NumberOfPoints from '@/components/dashboard/cards/number-of-points.vue';
import AnnualFees from '@/components/dashboard/cards/annual-fees.vue';
import CreditScore from '@/components/dashboard/cards/credit-score.vue';
import TopCard from '@/components/dashboard/cards/top-card.vue';
import SwCompanionPass from '@/components/dashboard/cards/sw-companion-pass.vue';
import StartGuide from '@/components/dashboard/cards/start-guide.vue';
import TxCourses from '@/components/dashboard/cards/tx-courses.vue';
import CourseProgress from '@/components/dashboard/cards/course-progress.vue';
import CourseFinish from '@/components/dashboard/cards/course-finish.vue';
import CompanionPassSection from '@/components/companion-pass/companion-pass-section.vue';

export default {
    name: 'Dashboard',
    props: [],
    components: {
        TxCourses,
        FiveTwentyFour,
        NumberOfCards,
        NumberOfPoints,
        AnnualFees,
        CreditScore,
        TopCard,
        SwCompanionPass,
        StartGuide,
        CourseProgress,
        CourseFinish,
        CompanionPassSection,
    },
    computed: {
        ...mapState(useDashboardStore, ['users', 'user']),
        ...mapState(useAppStore, ['userSettings']),
        ...mapState(useCompanionPassStore, ['passEnabled', 'setPassEnabled']),
        courseProgress() {
            return useCoursesStore().progress;
        },
    },
    data: () => ({
        showTxCourses: true,
    }),
    methods: {
        ...mapActions(useCreditScoreStore, ['getUserScore', 'setActiveUser']),
        ...mapActions(useDashboardStore, [
            'getDashboardData',
            'setUser',
            'getTopCard',
        ]),
        ...mapActions(useAppStore, ['setShowAffiliateModal']),
        toggleUserShown(user) {
            this.setUser(user);
            this.setActiveUser(user);
            this.getUserScore(user);
        },
        toggleCourse() {
            this.showTxCourses = !this.showTxCourses;
        },
    },
    created() {},
    mounted() {
        //this.setActiveUser(user);
        this.getUserScore();
        this.getDashboardData();
        this.getTopCard();
    },
    watch: {
        userSettings: {
            handler() {
                this.setPassEnabled(this.userSettings.companion_pass_enabled);
            },
        },
    },
};
</script>
